<div class="tutorial-wizard" [ngStyle]="drawerStyles | theme">
  <app-nav-button
    icon="close"
    (clickEvent)="onCloseClick()"
    [variant]="drawerConfig.closeButtonInverted ? 'secondary' : 'primary'"
    [size]="drawerConfig.closeButtonSize"
    [class]="drawerConfig.closeButtonPosition"
  />

  <div class="tutorial-wizard-content">
    <div [ngStyle]="titleStyles | theme" class="wizard-title">{{ currentPageTitle() }}</div>

    <div
      class="embla"
      emblaCarousel
      [options]="emblaOptions"
      [subscribeToEvents]="subscribeToEvents"
      (emblaChange)="onEmblaChange($event)"
    >
      <div class="embla__container">
        <ng-content select="[appTutorialSlide]"></ng-content>
      </div>
    </div>
  </div>

  <div class="tutorial-wizard-footer">
    <app-page-indicator [currentPage]="currentPage()" [totalPages]="totalPages()">
    </app-page-indicator>

    <div class="tutorial-wizard-buttons">
      <app-button
        class="next-button"
        [label]="nextLabel()"
        variant="primary"
        stretch="fill"
        (clickEvent)="onNextClick()"
      />
    </div>
  </div>
</div>
